import React from 'react';
import { Box } from '@atlaskit/primitives';
import { JiraPopup as Popup } from '@atlassian/jira-popup/src/ui/jira-popup.tsx';

export type ConfigureWorkTypePopupProps = {
	renderTarget: () => React.ReactNode;
	renderPopupContent: () => React.ReactNode;
	onClose: () => void;
};

export const ConfigureWorkTypePopup = ({
	renderTarget,
	renderPopupContent,
	onClose,
}: ConfigureWorkTypePopupProps) => {
	return (
		<Popup
			content={renderPopupContent}
			isOpen
			onClose={onClose}
			placement="bottom-start"
			messageId="issue-create.ui.modal.create-form.type-picker.configure-work-type.configure-work-type-popup.popup"
			messageType="transactional"
			trigger={(triggerProps) => (
				// eslint-disable-next-line react/jsx-props-no-spreading
				<Box role="button" {...triggerProps}>
					{renderTarget()}
				</Box>
			)}
			shouldRenderToParent
		/>
	);
};
